{
  "title": "Non-individual Entities",
  "entityType": "Entity Type",
  "typeOfTrust": "Type of Trust",
  "natureOfBusiness": "Nature of Business",
  "entityName": "Entity Name",
  "createNewNonIndividualEntity": "Create New Non-individual Entity",
  "relationships": "Relationships",
  "noRelationship": "There is no current relationships",
  "table": {
    "name": "Name",
    "entityType": "Entity Type",
    "primaryContact": "Primary Contact",
    "suitabilityScore": "Suitability Score",
    "notCompleted": "Not Completed",
    "completedAt": "Completed At",
    "noOfAccounts": "# of accounts",
    "totalAssets": "Total Assets",
    "organization": "Organization"
  },
  "editRelationship": "Edit Relationship",
  "addRelationship": "Add a New Relationship",
  "deleteRelationship": "Delete Relationship",
  "selectExistingUsers": "Select Existing Users",
  "createNewUser": "Create a New User",
  "edit": {
    "relationshipTo": "Relationship to {{whom}}"
  },
  "remove": {
    "areYouSure": "Are you sure you want to remove {{removedWhoName}}?",
    "thisWillNotDelete": "This will not delete the {{removedWhoName}}’s information, but they will no longer be associated with {{removedFromName}}.",
    "yesRemove": "Yes, Remove",
    "hasBeenRemoved": "Client has been removed from related entities list"
  }
}
